"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportRequestSchema = void 0;
const baseExportRequest_schema_1 = require("../../../common/schemas/export/baseExportRequest.schema");
const searchRequest_schema_1 = require("../search/searchRequest.schema");
exports.exportRequestSchema = baseExportRequest_schema_1.baseExportRequestSchema
    .merge(searchRequest_schema_1.searchRequestSchema.omit({ paging: true, highlight: true }))
    .strict();
//# sourceMappingURL=exportRequest.schema.js.map